import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const enappgyDataServiceApi = createApi({
  reducerPath: "enappgyDataServiceApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_DATA_URL
  }),
  tagTypes: [
    "Measurements",
    "ConsolidatedMeasurementBuilding",
    "ConsolidatedMeasurementFloor",
    "MeasurementsByFloor",
    "CostsMeasurements",
    "InterventionsMeasurement"
  ],

  endpoints: (builder) => ({
    //Queries
    getDataConsumptionByFilter: builder.query({
      query: ({ filter, locationId, tenantId }) => {
        // Converting the params object into a query string
        const queryString = Object.keys(filter)
          .map((key) => `${key}=${filter[key]}`)
          .join("&");

        return `Data/${tenantId}/${locationId}/MeasurementsByPeriod?${queryString}`;
      },
      providesTags: ["Measurements"]
    }),

    getSavings: builder.query({
      query: ({ filter, buildingId }) => {
        const queryString = Object.keys(filter)
          .map((key) => `${key}=${filter[key]}`)
          .join("&");
        return `CO2Calculations/${buildingId}?${queryString}`;
      },
      providesTags: ["Savings"]
    }),

    getDataByFilter: builder.query({
      query: ({ filter, locationId, tenantId }) => {
        // Converting the params object into a query string
        const queryString = Object.keys(filter)
          .map((key) => `${key}=${filter[key]}`)
          .join("&");

        return `Data/${tenantId}/${locationId}/MeasurementsByPeriod?${queryString}`;
      },
      providesTags: ["Measurements"]
    }),

    getDataCostsByFilter: builder.query({
      query: ({ filter, locationId, tenantId }) => {
        // Converting the params object into a query string
        const queryString = Object.keys(filter)
          .map((key) => `${key}=${filter[key]}`)
          .join("&");

        return `EnergyCosts/${tenantId}/${locationId}/EnergyCostsByPeriod?${queryString}`;
      },
      refetchOnMountOrArgChange: true,
      providesTags: ["CostsMeasurements"]
    }),

    getNormalDataConsumptionByFilter: builder.query({
      query: ({ filter, locationId, tenantId }) => {
        // Converting the params object into a query string
        const queryString = Object.keys(filter)
          .map((key) => `${key}=${filter[key]}`)
          .join("&");

        return `Data/${tenantId}/${locationId}/NormalMeasurementsByPeriod?${queryString}`;
      },
      providesTags: ["NormalMeasurements"]
    }),

    getConsolidatedMeasurementByBuilding: builder.query({
      query: ({ filter, locationId, tenantId }) => {
        const queryString = Object.keys(filter)
          .map((key) => `${key}=${filter[key]}`)
          .join("&");

        return `Data/${tenantId}/${locationId}/ConsolidatedMeasurementByBuilding?${queryString}`;
      },
      providesTags: ["ConsolidatedMeasurementBuilding"]
    }),

    getConsolidatedMeasurementByFloor: builder.query({
      query: ({ filter, locationId, tenantId }) => {
        const queryString = Object.keys(filter)
          .map((key) => `${key}=${filter[key]}`)
          .join("&");
        return `Data/${tenantId}/${locationId}/ConsolidatedMeasurementByFloor?${queryString}`;
      },
      providesTags: ["ConsolidatedMeasurementFloor"]
    }),

    getMeasurementsByFloor: builder.query({
      query: ({ filter, locationId, tenantId }) => {
        const queryString = Object.keys(filter)
          .map((key) => `${key}=${filter[key]}`)
          .join("&");
        return `Data/${tenantId}/${locationId}/MeasurementsByFloorWithAreas?${queryString}`;
      },
      providesTags: ["MeasurementsByFloor"]
    }),

    getDataCostsByFilterWithBenchMark: builder.query({
      query: ({ tenantId, id, queryParams }) => {
        // Converting the params object into a query string
        const queryString = Object.keys(queryParams)
          .map((key) => `${key}=${queryParams[key]}`)
          .join("&");

        return `EnergyCosts/${tenantId}/${id}/EnergyCostsWithBenchmarkByPeriod?${queryString}`;
      },
      refetchOnMountOrArgChange: true,
      providesTags: ["CostsMeasurementsWithBenchmark"]
    }),

    getInterventionsMeasurement: builder.query({
      query: ({ tenantId, locationId, queryParams }) => {
        const queryString = Object.keys(queryParams)
          .map((key) => `${key}=${queryParams[key]}`)
          .join("&");

        return `Interventions/${tenantId}/${locationId}/Measurement?${queryString}`;
      },
      providesTags: ["InterventionsMeasurement"]
    })
  })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetDataCostsByFilterWithBenchMarkQuery,
  useGetSavingsQuery,
  useGetDataCostsByFilterQuery,
  useLazyGetDataByFilterQuery,
  useGetMeasurementsByFloorQuery,
  useGetConsolidatedMeasurementByFloorQuery,
  useGetDataConsumptionByFilterQuery,
  useGetConsolidatedMeasurementByBuildingQuery,
  useGetNormalDataConsumptionByFilterQuery,
  useGetInterventionsMeasurementQuery
} = enappgyDataServiceApi;
